import type { TFunction } from "i18next";
import * as yup from "yup";

export const getEmailSchema = (t: TFunction) =>
  yup.string().email(t("COMMONS.ERRORS.INCORRECT_EMAIL")).required(t("COMMONS.ERRORS.REQUIRED"));
